import React from 'react';
import { Camera, FileSignature, FileText, Wrench, DollarSign, Stamp } from 'lucide-react';

const TYPES = [
  {
    icon: Camera,
    title: 'Listing photos and drone shots',
    body:
      'EXIF-aware routing for Sony, Canon, Nikon, Fujifilm, and DJI files. Sortio reads camera model, capture date, GPS (when present), and visible address signage in shots, then files per property and renames to a listing-friendly pattern like 1127 S Cornell Terrace - Kitchen - 01.jpg.',
  },
  {
    icon: FileSignature,
    title: 'Contracts and addenda',
    body:
      'Purchase agreements, listing agreements, buyer broker agreements, counter offers, addenda, amendments. Sortio reads each one for parties, effective date, and addendum number, then files under the matching property with a clean name and effective-date timestamp.',
  },
  {
    icon: Stamp,
    title: 'Disclosures and state forms',
    body:
      'Lead Based Paint disclosures, Seller Property Disclosures, FAR-BAR AS IS forms, HOA disclosures, flood zone forms. Sortio recognizes named forms and routes them under the property. Multi-state agents can split routing by state license, so a Florida disclosure never lands in a Texas property folder.',
  },
  {
    icon: Wrench,
    title: 'Inspection reports and repair docs',
    body:
      'Home inspection PDFs, termite (WDO) reports, sewer scope reports, roof certifications, repair invoices. Sortio extracts the inspection date and report type, files under the property, and groups repair receipts and invoices alongside the underlying inspection.',
  },
  {
    icon: DollarSign,
    title: 'Closing and commission docs',
    body:
      'ALTA settlement statements, seller net sheets, buyer cash to close worksheets, wire confirmation receipts, commission disbursement statements. Each lands under the property\'s Closing subfolder with a clean date-stamped filename. Commission and 1099 statements get routed to a separate tax archive automatically.',
  },
  {
    icon: FileText,
    title: 'MLS exports and showing notes',
    body:
      'MLS PDF tax cards, comp reports, showing service exports, lockbox access logs. Sortio recognizes the export source and routes each under the property folder so the deal record is complete at closing.',
  },
];

const DocumentTypes = () => {
  return (
    <section id="document-types" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Document types Sortio recognizes
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          The categories that show up inside an active transaction and how Sortio routes them.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TYPES.map((type, i) => {
          const Icon = type.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-primary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{type.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{type.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default DocumentTypes;
